// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".course-content[data-v-41c0a584]{position:relative;min-height:1080px;padding-top:60px;margin:auto;box-sizing:border-box;background-color:#f0f0f0;padding-bottom:60px}.course-content .course-main[data-v-41c0a584]{position:relative;width:1200px;margin:0 auto;background-color:#f0f0f0;height:100%}", ""]);
// Exports
module.exports = exports;
